import { defaultAxios, IParams } from './base';

export interface IFetchLoanPromotion extends IParams {
  promotionSeq: string;
}

export const fetchLoanPromotion = (params: IFetchLoanPromotion) => {
  return defaultAxios().post(`/loan/promotion`, params);
};
